var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarrantyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.25,
    height: 26.25,
    viewBox: "0 0 26.25 26.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.25px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7288",
    "data-name": "Path 7288",
    className: "cls-1",
    d: "M35.964,19.524a12.508,12.508,0,1,0,5.55,4.714l-10.205,12.6a1.191,1.191,0,0,1-1.719.138L23.924,31.9a1.19,1.19,0,1,1,1.588-1.773l4.734,4.238",
    transform: "translate(-17.875 -17.875)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarrantyWhite);
export default __webpack_public_path__ + "static/media/warrantyWhite.737e72288322a003613ce5a357f9db96.svg";
export { ForwardRef as ReactComponent };